module.exports = __webpack_public_path__ + "static/media/workingmemory-numbers-5.9c0ca530.mp3";